import { useMemo } from 'react';
import { createPortal } from 'react-dom';

// Get or create the portal root element (singleton pattern)
const getPortalRoot = () => {
  let container = document.getElementById('portal-root');
  if (!container) {
    container = document.createElement('div');
    container.id = 'portal-root';
    document.body.appendChild(container);
  }
  return container;
};

function Portal({ children }) {
  // Use useMemo to ensure we only get the portal root once
  const portalRoot = useMemo(() => getPortalRoot(), []);

  return createPortal(children, portalRoot);
}

export default Portal;
